/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DairyMachineUtilization { 
    standstill?: number;
    startup?: number;
    slowing_down?: number;
    production?: number;
    cip?: number;
    date?: string;
}

